import { bootstrapApplication } from '@angular/platform-browser';
import { getApplicationConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Amplify } from 'aws-amplify';
//import { awsConfig, licenseKeys } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';

// AG Grid 33+ needs its features registered, and keeps the CSS themes from styles.scss via 'legacy'
ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({ theme: 'legacy' });

async function loadRuntimeConfig() {
  const response = await fetch('./assets/config/runtime-config.json');
  const config = await response.json();

  (window as any).runtimeConfig = config;

  // Update page title
  if (config.tenant?.shortName) {
    document.title = config.tenant.shortName;
  }

  // Update favicon
  const favicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
    if (favicon && config.tenant.logo?.favicon) {
    favicon.href = config.tenant.logo.favicon;
  }

  registerLicense(config.licenseKeys.syncfusionLicenseKey);

  Amplify.configure(config.awsConfig);

  return config;
}

loadRuntimeConfig()
  .then((config) => {
    // Load tenant-specific features from runtime config
    if (config.features) {
      (window as any).tenantFeatures = config.features;
    }
    bootstrapApplication(AppComponent, getApplicationConfig()).catch((err) =>
      console.error(err)
    );
  })
  .catch((err) => {
    console.error('Failed to load configuration', err);
    throw err;
  });
